<template>
  <div :style="{height:this.h, width:this.w}">
    <div
      :id="name"
      class="google-map"
    />
  </div>
</template>

<script>
    export default {
        name: "GoogleMap",
      props: ['name', 'latC','lngC', 'h','w'],
      data() {
        return {
          //по дефолту координаты спб
          defaultLat: 59.930918,
          defaultLng: 30.336654,
          center:null,
          zoom:10,
          map:'',
          marker:null,
        }
      },
      computed:{

      },
      mounted () {
          if(this.latC==null||this.lngC==null)
            this.center={lat: this.defaultLat, lng: this.defaultLng};
          else{
            this.center = {lat: this.latC, lng: this.lngC};
          }

        const element = document.getElementById(this.name);
        const options = {
          zoom: this.zoom,
          center: new google.maps.LatLng(this.center),
          streetViewControl:false,
          mapTypeControl:false,
          rotateControl: false,
          fullscreenControl: false
        }
        //начальное положение карты
        this.map = new google.maps.Map(element, options)

        this.placeMarker(this.center);

        const vm=this;
        this.map.addListener('click', function(e) {
          var loc= {lat:e.latLng.lat(), lng:e.latLng.lng()}
          vm.placeMarker(loc);
        });

        this.$root.$on("locationChanged", function(val){
          vm.locationChange(val)
        })
      },
      methods: {
          //добавить точку на карту, записать в модель координаты
        placeMarker(location) {
          //удаляем текущий маркер если есть
          if (this.marker != null)
            this.marker.setMap(null);
          this.marker = new google.maps.Marker({position: location, map: this.map});
          //передаем выбранные координаты в модель
          this.$emit('markerChanged', location)
        },

        locationChange(location) {
        //удаляем текущий маркер если есть
          if (this.marker != null)
            this.marker.setMap(null);
          this.marker = new google.maps.Marker({position: location, map: this.map});
          this.map.setCenter(location);
        }
      }
    }
</script>

<style scoped>
  .google-map {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background: gray;
  }
</style>
